/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircleOutlined, BadgeOutlined, Flag, MoneyOutlined, QrCode2Outlined} from "@mui/icons-material";
import IngresoSelect from "../../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOSDEPOSITOS} from "../../../Constantes";
import IngresoDinero from "../../../Modulo_formularios/Componentes/IngresoDinero";
import {useEffect, useState} from "react";
import def from '../../../Recursos/img_default.svg'
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'

const Formulario_Deposito_Validar = ({...props}) => {
    const [recibo, setRecibo] = useState('');

    useEffect(() => {

        let img = props.props.getValues('img')
        if (img) {
            setRecibo(img)
        } else {
            setRecibo(def)
        }

    }, [props.props.watch('img')]);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={6}>
                    <IngresoSelect Icono={Flag} nombre={'Estado'} dato={'estado'} {...props}
                                   requerido={'El estado es requerido'}
                                   opciones={ESTADOSDEPOSITOS.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={QrCode2Outlined} nombre={'Consecutivo'} dato={'consecutivo'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre de Usuario'} dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'} editable={false}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={BadgeOutlined} nombre={'IdUnico Legible'} dato={'idUsuario'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero Icono={MoneyOutlined} nombre={'Valor'} dato={'valor'} {...props}

                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={MoneyOutlined} nombre={'Crypto'} dato={'tipo'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={6}>
                    <Zoom>
                        <img src={recibo} width={'100%'} height={'auto'}/>
                    </Zoom>
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto lineas={7} nombre={'Notas para Usuario'} dato={'detalle'} {...props}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Deposito_Validar